import React from "react";
import { Form } from 'react-bootstrap';

interface IProps {
    children: any,
    onSubmit?:(event: any) => void | undefined,
    hasErrors: boolean;
}

export const ValidatableForm = (props: IProps) => {
    return (
        <Form noValidate className={props.hasErrors ? "is-invalid" : ""} onSubmit={props.onSubmit}>
            {props.children}
        </Form>
    );
}